import { useState } from "react";
import toast from "react-hot-toast";
import { imagePath } from "../utils/imagePath";

const MissileSimulationPopup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BASE_URL + 'email/contact-us',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            message: `Access request for Missile Trajectory Simulation case study from ${formData.name}`,
            subject: 'Missile Trajectory Simulation - Access Request',
          }),
        }
      );

      if (response.ok) {
        toast.success(
          "Request submitted successfully! We'll get back to you soon.",
          {
            style: {
              background: '#1E1F22',
              color: '#FFFFFF',
              border: '1px solid #EE2B2A',
            },
            iconTheme: {
              primary: '#EE2B2A',
              secondary: '#FFFFFF',
            },
          }
        );
        setFormData({ name: '', email: '' });
        setTimeout(() => {
          onClose();
        }, 5000);
      } else {
        toast.error('Failed to submit request. Please try again.', {
          style: {
            background: '#1E1F22',
            color: '#FFFFFF',
            border: '1px solid #EE2B2A',
          },
          iconTheme: {
            primary: '#EE2B2A',
            secondary: '#FFFFFF',
          },
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Failed to submit request. Please try again.', {
        style: {
          background: '#1E1F22',
          color: '#FFFFFF',
          border: '1px solid #EE2B2A',
        },
        iconTheme: {
          primary: '#EE2B2A',
          secondary: '#FFFFFF',
        },
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] p-4 pt-24"
      onClick={onClose}
    >
      <div
        className="bg-[#1E1F22] rounded-lg max-w-2xl w-full relative shadow-2xl max-h-[84vh] z-[999999] md:max-h-[80vh] overflow-y-auto custom-scrollbar"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors w-8 h-8 flex z-[99999] items-center justify-center"
          aria-label="Close"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
        <div className="relative w-full h-[180px] sm:h-[200px] rounded-t-lg overflow-hidden">
          <img
            src={imagePath.MissileSimulation}
            alt="Missile Trajectory Simulation"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1E1F22] to-transparent" />
        </div>

        {/* Content */}
        <div className="px-6 py-3 sm:px-8 sm:py-5">
          {/* Header Banner */}
          <div className="mb-3 rounded">
            <h2 className="text-[#FFFFFF] text-xl sm:text-2xl font-bold font-jakarta mb-1">
              Missile Trajectory Simulation - Access Request
            </h2>
            <p className="text-[#D8D8D8] text-base leading-relaxed">
              This case study contains sensitive and confidential information.
              Access is restricted and available upon request only.
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Full Name Field */}
            <div>
              <label
                htmlFor="name"
                className="block text-[#A7A7A7] text-sm font-medium mb-2"
              >
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
                className="w-full bg-[#35373A] rounded-md px-4 py-2.5 text-[#FFFFFF] text-base placeholder:text-gray-400 placeholder:text-base outline-none focus:ring-2 focus:ring-[#EE2B2A]"
              />
            </div>

            {/* Email Address Field */}
            <div>
              <label
                htmlFor="email"
                className="block text-[#A7A7A7] text-sm font-medium mb-2"
              >
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
                className="w-full bg-[#35373A] rounded-md px-4 py-2.5 text-[#FFFFFF] text-base placeholder:text-gray-400 placeholder:text-base outline-none focus:ring-2 focus:ring-[#EE2B2A]"
              />
            </div>

            {/* Submit Button */}
            <div className="pt-2">
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-[#EE2B2A] hover:bg-[#d12625]  disabled:cursor-not-allowed text-white font-medium text-lg px-8 py-2 rounded-md transition-colors duration-200"
              >
                {isSubmitting ? 'Submitting...' : 'Request Access'}
              </button>
            </div>

            {/* Disclaimer */}
            <p className="text-[#D8D8D8] text-sm leading-relaxed relative bottom-2">
              Submitting this request does not guarantee access. Requests are
              subject to review and approval.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MissileSimulationPopup;
